module.exports = __webpack_public_path__ + "img/icon-info.a613fcba.svg";